<template>
  <div v-editable="blok">
    <div
      v-if="blok && heroBannerBloks"
      class="mx-break-out h-[65vh] max-h-[1330px] min-h-[550px]"
    >
      <HeroBannerSlider :blok="heroBannerBloks" class="h-full" />
    </div>
    <AgsLazy
      v-for="(content, index) in blok?.content"
      :key="content._uid"
      ssr
      :important="index <= (isMobile ? 0 : 1)"
      placeholder-ratio="16/9"
    >
      <StoryblokComponent :blok="content as any" />
    </AgsLazy>
  </div>
</template>

<script setup lang="ts">
import type { SbPage } from '~/cms/storyblok/types/storyblok.d.ts'

const props = defineProps<{ blok?: SbPage }>()

const heroBannerBloks = computed(() =>
  Array.isArray(props.blok?.heroBanner) && props.blok.heroBanner.length > 0
    ? props.blok.heroBanner
    : null,
)
const { isMobile } = useDeviceType()
</script>
